import { render, staticRenderFns } from "./party-info-add.vue?vue&type=template&id=6f5c0ca7&"
import script from "./party-info-add.vue?vue&type=script&lang=js&"
export * from "./party-info-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports